"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _userInfo = require("hub-http/userInfo");

var SchedulingTimezone =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SchedulingTimezone, _PureComponent);
  (0, _createClass2.default)(SchedulingTimezone, null, [{
    key: "propTypes",
    get: function get() {
      return {
        format: _react.default.PropTypes.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        format: 'default'
      };
    }
  }]);

  function SchedulingTimezone() {
    var _this;

    (0, _classCallCheck2.default)(this, SchedulingTimezone);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SchedulingTimezone).call(this));
    _this.state = (0, _extends2.default)({}, _this.getState());
    _this.renderFormat = _this.renderFormat.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SchedulingTimezone, [{
    key: "getState",
    value: function getState() {
      var offset = _I18n.default.moment.portalTz().format('Z');

      var timezoneName = (0, _userInfo.userInfoSync)().portal.timezone.id || '';
      var timezone = timezoneName.replace(/_/, ' ');
      return {
        offset: offset,
        timezone: timezone
      };
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor.scheduling.timezone." + suffix;
    }
  }, {
    key: "renderFormat",
    value: function renderFormat(format) {
      var _this$state = this.state,
          timezone = _this$state.timezone,
          offset = _this$state.offset;
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey(format || 'default'),
        options: {
          timezone: timezone,
          offset: offset
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var format = this.props.format;
      return _react.default.createElement(_Small.default, null, this.renderFormat(format), "\xA0", format ? _react.default.createElement(_UIHelpIcon.default, {
        title: this.renderFormat('tooltip')
      }) : null);
    }
  }]);
  return SchedulingTimezone;
}(_react.PureComponent);

exports.default = SchedulingTimezone;
module.exports = exports.default;